module.exports = __webpack_public_path__ + "static/media/banner_420x230_8.ff8d3bf0.jpg";